import Handler from '@/core/domain/usecase/handler';

const fetchServiceOrderRepository = (axios) => async (pagination) => {
    try {
        const response = await axios.get('/service-order', {
            params: pagination
        })

        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchServiceOrderRepository